// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2ib4E","colMin":"styles_colMin__3pBAB","colCheckbox":"styles_colCheckbox__29vFp"};